"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditarMascota = void 0;
var react_1 = __importStar(require("react"));
var recoil_1 = require("recoil");
var editPet_1 = require("../../hooks/editPet");
var index_css_1 = __importDefault(require("./index.css"));
var texts_1 = require("../../ui/texts");
var react_2 = require("@chakra-ui/react");
var edit_pet_form_1 = require("../../components/edit-pet-form");
var api_1 = require("../../lib/api");
var login_1 = require("../../hooks/login");
var react_router_dom_1 = require("react-router-dom");
function EditarMascota() {
    var editPetIdValue = (0, recoil_1.useRecoilValue)(editPet_1.editPetId);
    var setEditPetId = (0, recoil_1.useSetRecoilState)(editPet_1.editPetId);
    var tokenValue = (0, recoil_1.useRecoilValue)(login_1.token);
    var loginStateValue = (0, recoil_1.useRecoilValue)(login_1.loginState);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(), petData = _b[0], setPetData = _b[1];
    (0, react_1.useEffect)(function () {
        if (!loginStateValue) {
            navigate("/");
        }
        if (editPetIdValue) {
            (0, api_1.fetchMiMascotaById)(editPetIdValue, tokenValue).then(function (mascota) {
                var name = mascota.name, lat = mascota.lat, lng = mascota.lng, imageUrl = mascota.imageUrl, isFound = mascota.isFound, id = mascota.id;
                setPetData({
                    name: name,
                    lat: lat,
                    lng: lng,
                    imageUrl: imageUrl,
                    isFound: isFound,
                    id: id,
                });
                setEditPetId(undefined);
                setLoading(false);
            });
        }
    }, [editPetIdValue]);
    if (!loginStateValue) {
        return react_1.default.createElement("div", null);
    }
    return (react_1.default.createElement("div", { className: index_css_1.default.container },
        react_1.default.createElement(texts_1.CustomTitle, null, "Editar mascota"),
        loading ? react_1.default.createElement(react_2.Spinner, null) : react_1.default.createElement(edit_pet_form_1.EditPetForm, { petData: petData })));
}
exports.EditarMascota = EditarMascota;
